import { Agent, AgentAccessLevel } from "~/services/agents";

// Sharing an agent maps to the owner-only `can_share` grant; editors,
// USER-level grants, and SYSTEM agents (null access_level) never confer it.
// Drives the per-agent Share action (and the Share modal).
export const useCanShareAgent = (agent: Agent | undefined): boolean =>
  !!agent && agent.access_level === AgentAccessLevel.OWNER;
